import { NotificationState } from './types'

const initialState: NotificationState = {
  pushNotifications: [],
  selected: 0,
  error: undefined
}

export default initialState
